// extracted by mini-css-extract-plugin
export default {"studio__container":"styles_studio__container__b-xJE"};